import React, { memo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

function PerformanceHeader() {
  const { formatMessage } = useIntl();
  const { subEntityName } = useParams();

  return (
    <div className="fade-up">
      <div className={"title"}>
        {subEntityName && <>{subEntityName} - </>}
        {formatMessage({ id: "global.function.websiteTraffic" })}
      </div>
      <div className={"description"}>
        {formatMessage({ id: "analytics.websiteTraffic.description" })}
      </div>
      <div className="startRow" style={{ color: "#A5A5A5", marginTop: "8px" }}>
        <i className="meta-crm-icon-ic_info font-size-14 mgr4" />
        {formatMessage({ id: "global.tooltip.timeZone" })}
      </div>
    </div>
  );
}

export default memo(PerformanceHeader);
